
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/faqs/[...name]",
      function () {
        return require("private-next-pages/faqs/[...name].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/faqs/[...name]"])
      });
    }
  